import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'app/reducers';

const initialState = {};

const middleware = [thunk];

// const composeSetup = process.env.NODE_ENV !== 'production' && typeof window === 'object' &&
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const store = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
) : 
createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
  )
);

export default store;
